import { ObligationRulesGeneratorAllowedFields } from '@commenda/prisma';
import { ProfileFieldDefinition, ProfileFieldKey } from './fieldCatalog.types';
import {
  REVENUE_BAND_OPTIONS,
  TAX_CLASSIFICATION_OPTIONS,
  YES_NO_OPTIONS,
} from './fieldOptions';

const REVENUE_VALUES: Set<string> = new Set(
  REVENUE_BAND_OPTIONS.map((o) => o.value),
);

export const PROFILE_FIELD_CATALOG: Record<
  ProfileFieldKey,
  ProfileFieldDefinition
> = {
  [ObligationRulesGeneratorAllowedFields.EMPLOYEE_COUNT]: {
    key: ObligationRulesGeneratorAllowedFields.EMPLOYEE_COUNT,
    inputKind: 'number',
    label: 'How many employees does the entity have?',
    isAnswered: (value) => typeof value === 'number' && !Number.isNaN(value),
    toAnswerValue: (value) =>
      typeof value === 'number' && !Number.isNaN(value) ? value : undefined,
    toFormValue: (value) => value,
  },
  [ObligationRulesGeneratorAllowedFields.REVENUE_BAND]: {
    key: ObligationRulesGeneratorAllowedFields.REVENUE_BAND,
    inputKind: 'select',
    label: "What is the entity's annual revenue?",
    placeholder: 'Select a revenue band',
    options: REVENUE_BAND_OPTIONS,
    isAnswered: (value) =>
      typeof value === 'string' && REVENUE_VALUES.has(value),
    toAnswerValue: (value) =>
      typeof value === 'string' && REVENUE_VALUES.has(value)
        ? value
        : undefined,
    toFormValue: (value) => value,
  },
  [ObligationRulesGeneratorAllowedFields.HAS_FOREIGN_SUBSIDIARY]: {
    key: ObligationRulesGeneratorAllowedFields.HAS_FOREIGN_SUBSIDIARY,
    inputKind: 'radio',
    label: 'Does the entity have a foreign subsidiary?',
    options: YES_NO_OPTIONS,
    isAnswered: (value) => value === 'yes' || value === 'no',
    toAnswerValue: (value) =>
      value === 'yes' ? true : value === 'no' ? false : undefined,
    toFormValue: (value) =>
      typeof value === 'boolean' ? (value ? 'yes' : 'no') : value,
  },
  [ObligationRulesGeneratorAllowedFields.TAX_CLASSIFICATION]: {
    key: ObligationRulesGeneratorAllowedFields.TAX_CLASSIFICATION,
    inputKind: 'combobox',
    label: "What is the entity's tax classification? (optional)",
    placeholder: 'Select a tax classification',
    guidance:
      'If the entity has a tax election (e.g. an LLC taxed as a C Corp), select it so we generate the appropriate filings.',
    options: TAX_CLASSIFICATION_OPTIONS,
    // Optional everywhere it is configured — a missing classification is always "answered enough".
    isAnswered: () => true,
    toAnswerValue: (value) =>
      typeof value === 'string' && value !== '' ? value : undefined,
    toFormValue: (value) => value,
  },
};
